import { useMemo } from "react";

import { useGetFeatureFlags } from "api/queries/common/useGetFeatureFlags";
import { FEATURE_FLAGS } from "constants/featureFlags";

export default function useSupportChatProvider() {
  const { data: featureFlags, isLoading } = useGetFeatureFlags();

  const isIntercomEnabled = useMemo(
    () => featureFlags?.some((flag) => flag.key === FEATURE_FLAGS.WEB_10723_INTERCOM_CHAT && flag.is_enabled) ?? false,
    [featureFlags],
  );

  return {
    isReady: !isLoading,
    isIntercomEnabled: !isLoading && isIntercomEnabled,
    isHubspotEnabled: !isLoading && !isIntercomEnabled,
  };
}
